export const VOUCHER_TYPE_OPTIONS = [
  { value: 'contra_voucher', label: 'Contra Voucher' },
  { value: 'consumption_note', label: 'Consumption Note' },
  { value: 'concrete_estimator', label: 'Concrete Estimator' },
  { value: 'credit_note', label: 'Credit Note' },
  { value: 'cube_test_report', label: 'Cube Test Report' },
  { value: 'debit_note', label: 'Debit Note' },
  { value: 'delivery_challan', label: 'Delivery Challan' },
  { value: 'diesel_consumption_note', label: 'Diesel Consumption Note' },
  { value: 'general_journal_voucher', label: 'General Journal' },
  { value: 'goods_reciept_note', label: 'Goods Receipt Note' },
  { value: 'invoice', label: 'Invoice' },
  { value: 'payment_voucher', label: 'Payment Voucher' },
  { value: 'purchase_credit_note', label: 'Purchase Credit Note' },
  { value: 'purchase_debit_note', label: 'Purchase Debit Note' },
  { value: 'purchase_order', label: 'Purchase Order' },
  { value: 'quotation', label: 'Quotation' },
  { value: 'receipt_voucher', label: 'Receipt Voucher' },
  { value: 'sales_order', label: 'Sales Order' },
];
